/**
 * Shared Framer Motion animation variants for modals and UI components.
 * Import these to maintain consistent animations across the app.
 */

// Container with staggered children - wraps content that should animate sequentially
export const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.06,
      delayChildren: 0.1,
    },
  },
};

// Individual items that slide up - use as children of containerVariants
export const itemVariants = {
  hidden: { opacity: 0, y: 15 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: 'spring', stiffness: 300, damping: 24 },
  },
};

// Headers with scale effect - for modal titles
export const headerVariants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      type: 'spring', stiffness: 200, damping: 15, delay: 0.05,
    },
  },
};

// Icons with bounce effect - for emoji/icon reveals
export const iconVariants = {
  hidden: { opacity: 0, scale: 0.5 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      type: 'spring', stiffness: 300, damping: 15,
    },
  },
};

// Success states - for confirmation screens
export const successVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      type: 'spring', stiffness: 200, damping: 15,
    },
  },
};
